(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerBounds = {};
      this.isMobileQuery = window.matchMedia('(max-width: 749px)');
    }

    connectedCallback() {
      this.headerSection = document.querySelector('.section-header');
      this.announcementSection = document.querySelector('.announcement-bar-section');
      this.announcementBar = this.announcementSection
        ? this.announcementSection.querySelector('[data-announcement-sticky-type]')
        : null;

      this.headerStickyType = this.getAttribute('data-sticky-type') || 'none';
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.refreshAnnouncementSettings();
      this.updateMeasurements();
      this.applyInitialState();

      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
      this.isMobileQuery.addEventListener('change', this.onResizeHandler);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      this.isMobileQuery.removeEventListener('change', this.onResizeHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    }

    refreshAnnouncementSettings() {
      if (!this.announcementBar) {
        this.announcementStickyType = 'none';
        this.disableAnnouncementStickyOnMobile = false;
        this.isAnnouncementStickyActive = false;
        return;
      }

      this.announcementStickyType = this.announcementBar.dataset.announcementStickyType || 'none';
      this.disableAnnouncementStickyOnMobile = this.announcementBar.dataset.announcementDisableMobile === 'true';

      const isMobile = this.isMobileQuery.matches;
      this.isAnnouncementStickyActive =
        this.announcementStickyType !== 'none' &&
        !(this.disableAnnouncementStickyOnMobile && isMobile);
    }

    updateMeasurements() {
      this.refreshAnnouncementSettings();

      const root = document.documentElement;

      const announcementHeight =
        this.announcementSection && this.isAnnouncementStickyActive
          ? this.announcementSection.offsetHeight
          : 0;

      const announcementVisible =
        this.isAnnouncementStickyActive &&
        this.announcementSection &&
        !this.announcementSection.classList.contains('announcement-bar--hidden');

      root.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
      root.style.setProperty('--announcement-bar-offset', announcementVisible ? `${announcementHeight}px` : '0px');

      if (this.headerSection) {
        root.style.setProperty('--header-height', `${this.headerSection.offsetHeight}px`);
      }
    }

    applyInitialState() {
      if (this.headerStickyType !== 'none') {
        this.headerSection.classList.add('shopify-section-header-sticky');
      } else {
        this.headerSection.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      }

      if (this.announcementSection) {
        if (this.isAnnouncementStickyActive) {
          this.announcementSection.classList.add('announcement-bar--sticky');
          this.announcementSection.classList.remove('announcement-bar--hidden');
        } else {
          this.announcementSection.classList.remove('announcement-bar--sticky', 'announcement-bar--hidden');
        }
      }

      this.updateMeasurements();
    }

    onResize() {
      this.refreshAnnouncementSettings();

      if (this.announcementSection) {
        if (this.isAnnouncementStickyActive) {
          this.announcementSection.classList.add('announcement-bar--sticky');
        } else {
          this.announcementSection.classList.remove('announcement-bar--sticky', 'announcement-bar--hidden');
        }
      }

      this.updateMeasurements();
      this.createObserver();
    }

    createObserver() {
      if (!this.headerSection) return;

      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.headerSection.classList.add('scrolled-past-header');
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.headerSection.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.headerSection.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerStickyType === 'on-scroll-up') {
        this.headerSection.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }

      if (this.announcementSection && this.isAnnouncementStickyActive && this.announcementStickyType === 'on-scroll-up') {
        this.announcementSection.classList.add('announcement-bar--sticky', 'announcement-bar--hidden');
      }

      this.updateMeasurements();
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerStickyType === 'on-scroll-up') {
        this.headerSection.classList.add('shopify-section-header-sticky', 'animate');
        this.headerSection.classList.remove('shopify-section-header-hidden');
      }

      if (this.announcementSection && this.isAnnouncementStickyActive && this.announcementStickyType === 'on-scroll-up') {
        this.announcementSection.classList.add('announcement-bar--sticky');
        this.announcementSection.classList.remove('announcement-bar--hidden');
      }

      this.updateMeasurements();
    }

    reset() {
      if (this.headerStickyType === 'on-scroll-up') {
        this.headerSection.classList.remove('shopify-section-header-hidden', 'animate');
        this.headerSection.classList.add('shopify-section-header-sticky');
      }

      if (this.announcementSection && this.isAnnouncementStickyActive && this.announcementStickyType === 'on-scroll-up') {
        this.announcementSection.classList.add('announcement-bar--sticky');
        this.announcementSection.classList.remove('announcement-bar--hidden');
      }

      this.updateMeasurements();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.headerSection.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.headerSection.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
